class UrlFilter {
    constructor() {
        this.url = window.location.pathname;
        this.parts = this.splitUrl();
    }

    /**
     * @returns {string|null}
     */
    get filter() {
        if (this.parts.length === 3) {
            return this.parts[2].toUpperCase();
        }

        return null;
    }

    /**
     * @param filter
     */
    setFilter(filter) {
        let url = this.parts;
        if (url.length === 3 || url.length === 2) {
            url[2] = filter;
        }
        window.history.pushState('', '', url.join("/"));
    }

    /**
     * @returns {*[]|*}
     */
    splitUrl() {
        if (this.url !== undefined && this.url !== null) {
            return this.url.split("/");
        }

        return [];
    }
}

export default UrlFilter;